import React from 'react';
import { AppList } from "components/list/AppList";

import { Datagrid, TextField } from 'react-admin';

import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { DatagridWithBlockDeleteProps } from '../../../components/_helpers/props/DatagridProps';
import { stylesForColorInheritInList } from '../../../components/_helpers/useStyles';
import { DeleteButton } from '../../../components/toolbars/DeleteButton';

import { ClientNotificationSubscriptionFilter } from './ListFilters';
import { ThirdPartyField } from 'components/fields/ThirdPartyField';
import { SelectEnumField } from 'components/fields/SelectEnumField';
import { NotificationSubscriptionEventType } from 'entities/NotificationSubscriptionEventType';
import { DateTimeField } from 'components/fields/DateFormatField';


const defaultSort = { field: 'id', order: 'DESC' };


export const ClientNotificationSubscriptionList = (props) => {
	const classes = stylesForColorInheritInList();

	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			filters={<ClientNotificationSubscriptionFilter />}
			classes={classes}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockDeleteProps}
					rowClick='show'
				>
					<TextField source='id' />
					<SelectEnumField source="event_type" 
						enumObj={NotificationSubscriptionEventType} enumName="notification_subscription" />
					<ThirdPartyField source='oauth2_client_id' />
					<DateTimeField source='created_at' withLocalTimeZone />
					<DeleteButton 
						resource={props.resource}
						notifyMessage="osfc.dialogs.confirm_delete_notification_subscription.success"
						title="osfc.dialogs.confirm_delete_notification_subscription.confirm.title"
						content="osfc.dialogs.confirm_delete_notification_subscription.confirm.content"
					/>
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};
